export default __webpack_public_path__ + "static/img/android_app_img.63ee267.png";